import React, { CSSProperties } from 'react';

interface SewerWaterProps {
  detailListStyle: CSSProperties,
  sewer: Array<string> | undefined,
  water: Array<string> | undefined,
}

const SewerWater = ({detailListStyle, sewer, water}: SewerWaterProps) => {

	if (water === undefined)
		water = [];
  
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-faucet me-2" />
        Utilities
			</p>
			<ul style={detailListStyle}>
				{sewer && sewer.map((item: string, i: number) => {
					return <li key={i}><span className="cc-font-weight--normal">Sewer:</span>&nbsp;{item}</li>;
				})
				}
				{water.length > 0 && <li><span className="cc-font-weight--normal">Water source:</span>&nbsp;{water.join(', ')}</li>}

				{(!sewer && water.length === 0) && <li>None listed</li> }
			</ul>
		</React.Fragment>
	);
};

export default SewerWater;